"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderDownloadCell = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FileDownloadOutlined = _interopRequireDefault(require("@mui/icons-material/FileDownloadOutlined"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
var _actions = require("../../redux/actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const RenderDownloadCell = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    fileData,
    filenameFunc
  } = _ref;
  const {
    url,
    name
  } = fileData;
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const dispatch = (0, _reactRedux.useDispatch)();
  if (!url) return null;
  const handleDownload = () => {
    var _filenameFunc;
    const fileFormat = url === null || url === void 0 ? void 0 : url.split('.').slice(-1)[0];
    const fileName = name.length ? name : (_filenameFunc = filenameFunc === null || filenameFunc === void 0 ? void 0 : filenameFunc(tV)) !== null && _filenameFunc !== void 0 ? _filenameFunc : url.split('/').slice(-1)[0].split(".".concat(fileFormat))[0];
    dispatch((0, _actions.downloadFile)({
      url,
      filename: "".concat(fileName, ".").concat(fileFormat)
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: handleDownload
  }, /*#__PURE__*/_react.default.createElement(_FileDownloadOutlined.default, {
    sx: {
      color: _constants.colors['main-color-cl-10']
    }
  }));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _paulCorePackage.functions.areEqual(prev.fileData, next.fileData) && prev.filenameFunc === next.filenameFunc;
});
exports.RenderDownloadCell = RenderDownloadCell;
RenderDownloadCell.propTypes = {
  fileData: _propTypes.default.shape({
    name: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  filenameFunc: _propTypes.default.func
};
RenderDownloadCell.defaultProps = {
  fileData: {
    name: '',
    url: ''
  }
};